import { useSortable } from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';
import { Box, Checkbox, ListItem, ListItemButton, ListItemIcon, ListItemText, Stack } from "@mui/material";
import React from "react";
import ListDragHandle from "../list-drag-handle/ListDragHandle";



export type CheckListItemProps = {
    id?: string;
    displayText: string;
    secondaryText?: string;
    tertiaryText?: string;
    checked: boolean;
    onClick: () => void;
    icon?: React.ReactNode;
    checkedIcon?: React.ReactNode;
    enableDnd?: boolean;
    disabled?: boolean;
    active: boolean;
    avatar?: React.ReactNode;
    objectID?: number
};

export function CheckListItem({
    id,
    displayText,
    secondaryText,
    tertiaryText,
    checked,
    onClick,
    icon,
    checkedIcon,
    enableDnd,
    disabled,
    active,
    avatar,
    objectID
}: CheckListItemProps) {

    const {
        attributes,
        listeners,
        transform,
        transition,
        isDragging,
        setNodeRef,
        setActivatorNodeRef
    } = useSortable({ id: id ?? '' });

    return (
        <ListItem
            ref={enableDnd ? setNodeRef : undefined}
            dense
            disablePadding
            sx={{
                margin: 0,
                transform: CSS.Transform.toString(transform),
                transition,
                opacity: isDragging ? theme => theme.palette.action.disabledOpacity : 1,
                position: 'relative'
            }}
        >
            <ListItemButton
                disabled={disabled}
                onClick={onClick}
            >
                {enableDnd && <ListDragHandle
                    ref={setActivatorNodeRef}
                    {...listeners}
                    {...attributes}
                    sx={{
                        position: "absolute",
                        //left: "50%",
                        right: 0,
                        transform: "translate(-50%, 0)"
                    }}
                />
                }
                <ListItemIcon>
                    <Checkbox
                        edge="start"
                        checked={checked}
                        tabIndex={-1}
                        disableRipple
                        icon={icon}
                        checkedIcon={checkedIcon}
                    />
                </ListItemIcon>
                <ListItemIcon
                    sx={{
                        minWidth: "32px"
                    }}
                >
                    {avatar ? avatar : undefined}
                </ListItemIcon>

                <ListItemText
                    primary={objectID ? `${displayText} [${objectID}]` : displayText}
                    secondary={
                        <Stack direction="column">
                            <Box component="span" sx={{ display: "block" }}>
                                {secondaryText}
                            </Box>
                            {tertiaryText &&
                                <Box component="span" sx={{ display: "block" }}>
                                    {tertiaryText}
                                </Box>
                            }
                        </Stack>
                    }
                    sx={{
                        fontStyle: active === false ? 'italic' : 'normal',
                    }}
                />
            </ListItemButton>
        </ListItem>
    );
}
